<template>
  <div class="fluid ">    
    <div class="col-md-2">		
		<!-- <b-overlay :show="show" rounded="sm"> -->
			<p><a @click="mergePDFDocuments" class="btn btn-default" :disabled="list.length === 0"><i class="fa fa-download"></i>Hent hæfte</a></p>

			<p><button type="button" class="btn btn-default" @click="removeAll" :disabled="list.length === 0"><i class="fa fa-trash fa-lg" />Fjern alle sider</button></p> 
		<!--  </b-overlay> -->
		
		  <draggable class="list-group" tag="ul" v-model="list" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
			<transition-group type="transition" :name="'flip-list'">
			  <li class="list-group-item" v-for="(element,i) in list" :key="element.order">							
				<div class="profile-pic">
					<img :src="element.tn" class="thumbnail"/>				
					<div class="edit"><a @click="removeItem(i)"><i class="fa fa-trash fa-lg"></i></a></div>				
					<span class="badge">Side {{i+1}}</span>	
				</div>				
			  </li>			  
			</transition-group>
		  </draggable>
    </div>
  </div>
  
</template>

<script>
import draggable from "vuedraggable";
import { PDFDocument } from "pdf-lib";
import download from "downloadjs";
import eventBus from './event-bus'

export default {
  name: "hello",
  components: {
    draggable,
	PDFDocument,
	download,
  },
  data() {
    return {
      list: [],	  	  
      isDragging: false,
      delayedDragging: false,
	  show: false
    };
  },
  methods: {
  
    removeAll() {
      this.list = [];
	  
	  		this.$notify({
			  group: 'foo',
			  title: 'Alle sider fjernet',
			  type: 'success',
			  text: '',
		      duration: 2000, 
			  speed: 500
			});
		
    },
	removeItem: function(index) {
		this.list.splice(index, 1);
	},
    
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },	
	async mergePDFDocuments() 
	{
		if(this.list.length === 0) return;
		
		var t1 = performance.now()		
		this.show = true;
					
		this.$notify({
			  group: 'foo',
			  title: 'Forbereder hæftet til hentning',
			  type: 'success',
			  text: 'Tiden afhænger af antallet af sider, der er i hæftet',
		      duration: 5000, 
			  speed: 500
			});
		
		const mergedPdf = await PDFDocument.create();
		
		for (let document of this.list) {
			try {		
				var data = null;
				if(document.binary == null) {							
					document.binary = await PDFDocument.load(await fetch(process.env.BASE_URL + "/bygselv/pages/" + document.pdf).then(res => res.arrayBuffer()))					
				}
				var pages = document.binary;								
						
				const copiedPages = await mergedPdf.copyPages(pages, pages.getPageIndices());
				copiedPages.forEach((page) => mergedPdf.addPage(page));    
			}
			catch (error) {
				ga('send', {hitType: 'event', eventCategory: 'Bygselv', eventAction: 'Fejl-hent', eventLabel: document.pdf + ''});
			}	
		}
		
		var binary = await mergedPdf.save();		
		this.show = false; 
		
		download(binary, "LegogLektieHaefte.pdf", "application/pdf");		
		
		ga('send', {hitType: 'event', eventCategory: 'Bygselv', eventAction: 'DownloadHaefte', eventLabel: this.list.length + '  sider' });
		ga('send', {hitType: 'event', eventCategory: 'Bygselv', eventAction: 'GenerateHaefte', eventLabel: (performance.now() - t1) + ' ms' });
		console.log((performance.now() - t1) + ' ms');
	},
	highestOrder(){
		if (this.list.length == 0) return 
		return this.list.reduce((a,b) => Number(a.order) > Number(b.order) ? a : b)    
	},
	async loadBinary(data){
		data.binary = await  PDFDocument.load(await fetch("https://www.legoglektie.dk/bygselv/pages/" + data.pdf).then(res => res.arrayBuffer()));
	}
  },  
  
  computed: {
  
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false, //kan fjernes
        ghostClass: "ghost"
      };
    },    
  },
    
   created (){
    eventBus.$on('click',(data) => {	
		console.log('Event click');
		data.order = this.list.length + 1;	
		this.list.push(data);
		this.loadBinary(data)		
    })     
  },
  
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    }
  }
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.thumbnail {
width:200px;
}

.profile-pic {
	margin-top:10px;
	position: relative;
	display: inline-block;
}

.profile-pic:hover .edit {
	display: block;
}

.edit {
	padding-top: 7px;	
	padding-right: 7px;
	position: absolute;
	right: 0;
	top: 0;
	display: none;
}
.edit a {
	color: #000;
}

.fa {
	margin-right: 6px;
}
</style>
